import { useEffect, useRef } from 'react';

type IntervalCallback = () => void;

export default function useInterval(callback, delay) {
  const savedCallback = useRef<IntervalCallback>(callback);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
